import { gql } from "@apollo/client";

export const GET_CATEGORIES = gql`
  query getCategories(
    $catalogId: CatalogID!
    $first: Int!
    $cursor: String
    $search: String
  ) {
    categories(
      catalogId: $catalogId
      first: $first
      after: $cursor
      search: $search
      sort: "title"
    ) {
      edges {
        node {
          id
          title
          handle
          level
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;
